import { render } from "./FormInput.vue?vue&type=template&id=976a1068"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\vuejs-Nico-portfolio-main\\vuejs-tailwindcss-portfolio-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__